<template>
  <div
    class="SkeletonBox SkeletonBox-animation"
    :style="{
      height: height,
      width: width,
      marginBottom: margin,
    }"
  ></div>
</template>

<script>
export default {
  name: "SkeletonBox",
  props: {
    height: String,
    width: String,
    margin: String,
  },
};
</script>

<style lang="scss">
.SkeletonBox-animation {
  background-color: #dddbdd;
  overflow: hidden;
  position: relative;
  vertical-align: middle;

  &::after {
    animation: shimmer 5s infinite;
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>
